import { useFetchStatusQuery } from "./statusApiSlice";

export default function Status() {
	const { data, isFetching } = useFetchStatusQuery();

	return (
		<>
			<section>
				<h2 className="mt-12 mb-8">Client Status</h2>
				<div className="shadow-sm overflow-hidden my-8">
					<table className="tbl tbl-data">
						<thead>
							<tr>
								<th>Attribute</th>
								<th>Value</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Package Version</td>
								<td>{__VERSION__}</td>
							</tr>
							<tr>
								<td>Branch</td>
								<td>{__BRANCH_NAME__}</td>
							</tr>
							<tr>
								<td>Git Version</td>
								<td>
									{__GIT_VERSION__}-{__GIT_COUNT__}
								</td>
							</tr>
							<tr>
								<td>Commit Hash</td>
								<td>
									{__SHORT_HASH__} ({__COMMIT_HASH__})
								</td>
							</tr>
							<tr>
								<td>Commit Date</td>
								<td>{__COMMIT_DATE__}</td>
							</tr>
							<tr>
								<td>Build Date</td>
								<td>{__BUILD_DATE__}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<section>
				<h2 className="mt-12 mb-8">Server Status</h2>
				<p>{isFetching ? "Fetching..." : data?.summary ?? "Summary not available."}</p>

				<div className="shadow-sm overflow-hidden my-8">
					<table className="tbl tbl-data">
						<thead>
							<tr>
								<th>Component</th>
								<th>Address</th>
								<th>Status</th>
								<th>Response</th>
								<th>Messages</th>
							</tr>
						</thead>
						<tbody>
							{data?.rows.map((row) => (
								<tr key={row.component}>
									<td>{row.component}</td>
									<td>{row.address}</td>
									<td>{row.status}</td>
									<td>{row.response}</td>
									<td>
										{row.messages.map((message, index) => {
											if (index === 0) return message;
											return (
												<>
													<br />
													{message}
												</>
											);
										})}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</section>
		</>
	);
}
